import { Button, Form, Spinner } from "react-bootstrap";
import { useWindowSize } from "../../../../hooks";
import ExcelButton from "../../../../components/ExcelButton";
import { useNotificadoresStore } from "../../../../store/notificadoresStore";
import ExcelFront from "../../../../components/ExcelFront";
import { filtrarActas } from "../../../ReportesNotificadores/handler";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import { useEffect, useState } from "react";

const FilterBarNotificador = ({ filterActas, excel = 'back' }) => {

    const size = useWindowSize()
    const { loads } = useGeneralAppStore();
    const { actas, filterActasEstado, setFilterActasEstado, setFilterFields, setBuscar, setFilterEstado, buscar, filterEstado, order } = useNotificadoresStore();
    const [newFilterActas, setNewFilterActas] = useState();

    useEffect(() => {
        if (filterActas) {
            const newFilterActas = filterActas.map((acta) => {
                return {
                    ...acta,
                    fecha_asignado: acta.notificadores[0]?.fecha_asignado,
                }
            })
            setNewFilterActas(newFilterActas)
        }
    }, [filterActas])


    const headers = [
        { label: "ID", key: "id" },
        { label: "#Acta", key: "numero_acta" },
        { label: "Documento", key: "documento_titular" },
        { label: "Patente", key: "plate" },
        { label: "Direccion", key: "direccion_titular" },
        { label: "Fecha asignado", key: "notificadores[0].fecha_asignado" },
    ];

    return (
        <>
            <section className="d-flex justify-content-between w-100 border border-1 border-secondary-subtle rounded">
                <div className="d-column  d-md-flex px-3  px-md-5  gap-5  pb-3 pt-1 w-100">
                    <div className="d-flex w-100 justify-content-between">
                        <Form.Group className="d-flex flex-column justi-align-items-center">
                            <Form.Label className="m-0 w-100 text-center" style={{ fontSize: "0.8rem" }}>
                                Buscar
                            </Form.Label>
                            <Form.Control
                                value={buscar}
                                size="sm"
                                onChange={(e) => {
                                    setFilterFields('search', e.target.value);
                                    setBuscar(e.target.value);

                                }}
                            ></Form.Control>
                        </Form.Group>
                        {
                            size.width < 576 &&
                            <div className=" d-flex flex-column align-items-center " style={{ width: "130px", minHeight: "61px" }}>
                                <span className={`${actas?.length != filterActas?.length && "text-success"} fw-bold`} style={{ fontSize: "0.8rem" }}>{actas?.length != filterActas?.length ? "Actas filtradas" : "Actas"}</span>
                                <div className="d-flex align-items-start">
                                    {/* <span className={`${actas?.length != filterActas?.length && "text-success"} fw-bold`}>{filterActas?.length}</span> */}
                                    {
                                        newFilterActas &&
                                        <>
                                            {
                                                loads.includes('load_actas_notificador')
                                                    ?
                                                    <Spinner size="lg" />
                                                    :

                                                    <ExcelFront headers={headers} data={newFilterActas} filename={"listado-actas.csv"} />
                                            }
                                        </>
                                    }
                                    {/* <ExcelButton headers={headers} data={filterActas} filename={"listado-actas.csv"} /> */}
                                </div>
                            </div>
                        }
                    </div>

                    <Form.Group className="d-flex flex-column justi-align-items-center mt-3 m-md-0">
                        <Form.Label className="m-0 w-100 text-center mb-2" style={{ fontSize: "0.8rem" }}>
                            Actas
                        </Form.Label>
                        <div className={`d-flex  gap-2 align-items-center`}>
                            {/* <Button size="sm" variant={`${filterActasEstado == "Todas" ? "primary" : "secondary"}`} style={{ minWidth: "100px", width: "100px", fontSize: "12px", padding: "6px 0" }} onClick={() => { */}
                            <Button size="sm" variant={`${filterEstado == "todas" ? "primary" : "secondary"}`} style={{ minWidth: "100px", width: "100px", fontSize: "12px", padding: "6px 0" }} onClick={() => {

                                setFilterActasEstado('Todas');
                                setFilterEstado('todas');
                            }}>Todas</Button>
                            {/* <Button size="sm" variant={`${filterActasEstado == "Notificadas" ? "primary" : "secondary"}`} style={{ minWidth: "100px", width: "100px", fontSize: "12px", padding: "6px 0" }} onClick={() => { */}
                            <Button size="sm" variant={`${filterEstado == "notificadas" ? "primary" : "secondary"}`} style={{ minWidth: "100px", width: "100px", fontSize: "12px", padding: "6px 0" }} onClick={() => {
                                setFilterActasEstado('Notificadas');
                                setFilterEstado('notificadas');
                            }}>Notificadas</Button>
                            {/* <Button size="sm" variant={`${filterActasEstado == "No notificadas" ? "primary" : "secondary"}`} style={{ minWidth: "100px", width: "100px", fontSize: "12px", padding: "6px 0" }} onClick={() => { */}
                            <Button size="sm" variant={`${filterEstado == "no-notificadas" ? "primary" : "secondary"}`} style={{ minWidth: "100px", width: "100px", fontSize: "12px", padding: "6px 0" }} onClick={() => {
                                setFilterActasEstado('No notificadas');
                                setFilterEstado('no-notificadas');
                            }}>No notificadas</Button>
                        </div>
                    </Form.Group>
                </div>

                {
                    size.width >= 576 &&
                    <div className=" d-flex flex-column align-items-center " style={{ width: "130px" }}>
                        <span className={`${actas?.length != filterActas?.length && "text-success"} fw-bold`} style={{ fontSize: "0.8rem" }}>{actas?.length != filterActas?.length ? "Actas filtradas" : "Actas"}</span>
                        <div className="d-flex align-items-start justify-content-center">
                            {
                                loads.includes('load_actas_notificador')
                                    ?
                                    <Spinner size="sm" />
                                    :
                                    <>
                                        {
                                            newFilterActas &&
                                            <>

                                                {
                                                    excel == 'front'
                                                        ?
                                                        <ExcelFront headers={headers} data={newFilterActas} filename={"listado-actas.csv"} />
                                                        :
                                                        <ExcelButton headers={headers} data={newFilterActas} filterFields={{
                                                            "estado_id": filterEstado,
                                                            "buscar": buscar,
                                                            "order": order,
                                                        }} filename={"listado-actas.csv"} />
                                                }
                                            </>
                                        }
                                    </>

                            }

                        </div>
                    </div>
                }
            </section>
        </>

    );
};
export default FilterBarNotificador;
